import { render, staticRenderFns } from "./ProcessAntragHeader.vue?vue&type=template&id=0591def4&"
import script from "./ProcessAntragHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessAntragHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports